import { RequestBase } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBase, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { UserLicense } from "../user-license";
import { UserState } from "../user-state";

export class RequestLicenseUserSet extends RequestBase {
  licenseId?: string | null;
  data?: string[] | null;
  assign?: boolean | null;

}

export class ResponseLicenseUserSet extends ResponseBase {
  data?: string[] | null;
  assign?: boolean | null;
}


export class RequestUserLicense extends RequestBase {
  active?: boolean | null = true;
}

export class ResponseUserLicense extends ResponseBaseSet<UserLicense> {
}

export class RequestUpdateUser extends RequestBase {
  LicenseId?: string | null;
  Assigned?: boolean | null;
  Active?: boolean | null;
  UserId?: string | null;
}

export class ResponseUpdateUser extends ResponseBaseSet<UserState> {
}
